// DateUY is the collection's business date in America/Montevideo, supplied by the API.
export function formatVisitIncomeDate(row) {
  const businessDate = row?.DateUY;
  if (/^\d{4}-\d{2}-\d{2}$/.test(businessDate || "")) {
    const [year, month, day] = businessDate.split("-");
    return `${day}-${month}-${year}`;
  }

  if (!row?.DateTime) return "-";
  const date = new Date(row.DateTime);
  if (Number.isNaN(date.getTime())) return "-";
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "America/Montevideo",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).formatToParts(date);
  const value = (type) => parts.find((part) => part.type === type)?.value;
  return `${value("day")}-${value("month")}-${value("year")}`;
}
